/**
 * =============================================================================
 * Deenex AI - Frontend Entry Point
 * =============================================================================
 * 
 * Main entry point for the React application.
 * Renders the root App component into the DOM.
 * 
 * @module main
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './shared/components/ErrorBoundary';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        {/* Boundary de la raíz: cubre también los providers y las rutas públicas. Su fallback
            sólo ofrece recargar (ver ErrorFallback). Las pantallas del layout tienen el suyo. */}
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);
